export default {
  apiKey: 'AIzaSyCrzkpw0Lqt9gL3Do4U32FUMkBndp5jra4',
  authDomain: 'home.solo.md',
  databaseURL: 'https://solo-home.firebaseio.com',
  projectId: 'solo-home',
  storageBucket: 'solo-home.appspot.com',
  messagingSenderId: '263220188083'
}
